import { render, staticRenderFns } from "./BatimentHeader.vue?vue&type=template&id=1c96af7c&scoped=true&"
import script from "./BatimentHeader.vue?vue&type=script&lang=js&"
export * from "./BatimentHeader.vue?vue&type=script&lang=js&"
import style0 from "./BatimentHeader.vue?vue&type=style&index=0&id=1c96af7c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c96af7c",
  null
  
)

export default component.exports